export { default as default } from '../modules/PhoneInputWithCountry.js'
export { default as formatPhoneNumber, formatPhoneNumberIntl } from '../modules/libphonenumber/formatPhoneNumber.js'

export {
	default as parsePhoneNumber,
	isValidPhoneNumber,
	isPossiblePhoneNumber,
	getCountryCallingCode,
	getCountries,
	isSupportedCountry
} from 'libphonenumber-js/core'


//////////////////
// WEBPACK FOOTER
// ../react-phone-number-input/core/index.js
// module id = 317
// module chunks = 0 1